import type { FlowError } from "../flow/machine";
import { t } from "../i18n";

export function errorMessage(e: FlowError): string {
  const key = `error.${e.code}`;
  const direct = t(key, { message: e.message });
  if (direct !== key) return direct;
  if (e.code.startsWith("api_")) return t("error.api", { message: e.message });
  return t("error.unexpected", { message: e.message });
}

export function ErrorBanner({ error, onRetry }: { error: FlowError; onRetry: () => void }) {
  return (
    <div class="notice danger" role="alert">
      <h3>{t("error.heading")}</h3>
      <p>{errorMessage(error)}</p>
      <p class="hint"><code>{error.code}</code></p>
      {error.retryable && (
        <button type="button" class="primary" onClick={onRetry}>{t("common.retry")}</button>
      )}
    </div>
  );
}
